import { transformPathName, transformSlug } from '@/js/helpers/transform-slug'
import { UTM } from '@/js/enums/utm'
import { seoUtmSource } from '@/js/constants/seo-variables'
const moveToLand = () => {
  const btns = document.querySelectorAll('.grades__item')

  btns.forEach(btn => {
    btn.addEventListener('click', () => {
      const grade = btn.getAttribute('data-value')
      const landUrl = btn.getAttribute('data-url')

      if (grade && landUrl) {
        const currentUrl = new URL(window.location.href)
        const currentPathName = transformPathName(currentUrl.pathname) || 'main'
        const btnText = transformSlug(btn.textContent)
        const url = new URL(landUrl, window.location.origin)
        url.searchParams.set('grade', grade)
        url.searchParams.set(UTM.UTM_SOURCE, seoUtmSource)
        url.searchParams.set(UTM.UTM_MEDIUM, currentPathName)
        url.searchParams.set(UTM.UTM_CAMPAIGN, 'banner')
        url.searchParams.set(UTM.UTM_CONTENT, btnText)
        window.location.href = url
      }
    })
  })
}

export default moveToLand
